import store from '../store'
import toast from './toast.vue';


window.IMC_VUE_SYS =  new Vue({
    store,
    el: '#imc_app',
    name : "IMCSYS",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        toast,
    }
});
